import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import styles from '../RetakeQuizDrawer/styles.module.scss';
import ResultsAnimation from "Root/quiz/elements/resultsAnimation";
import RegFont from "../common/RegFont";
import useRetakeQuizDrawer from "../RetakeQuizDrawer/useRetakeQuizDrawer";
import BottomBar from "../common/BottomBar";
import LargeFont from "../common/LargeFont";
const RetakeQuizExtraQuestions = ({ quizData, loading, submitAnswers, showAnimation, notAnsweredQuestions, getUIElement, }) => {
    const ref = useRef(null);
    const extraRef = useRef(null);
    const { isMobile, expanded, setExpanded } = useRetakeQuizDrawer(quizData);
    const submit = async () => {
        if (ref.current) {
            ref.current.scrollIntoView();
        }
        if (extraRef.current) {
            extraRef.current.scrollIntoView();
        }
        await submitAnswers();
    };
    return (_jsxs(React.Fragment, { children: [_jsx("div", { ref: extraRef, className: [styles.extra_drawer, showAnimation && styles.show_animation].join(" "), children: showAnimation ? (_jsx("div", { className: styles.animation, children: _jsx(ResultsAnimation, { text: "Updating your Formula...", goNext: () => null }) })) : (_jsxs(_Fragment, { children: [_jsx(LargeFont, { children: notAnsweredQuestions.length === 1 ? "Just One More question" : "We have a few more questions for you" }), _jsx("div", { className: styles.not_answered_questions, children: notAnsweredQuestions.map((question, index) => (_jsxs("div", { className: styles.question_ui, children: [_jsx(RegFont, { children: question.title }), _jsx("div", { className: styles.accordion_details, children: getUIElement(question) })] }, question.questionName))) })] })) }), _jsx(BottomBar, { disabledSave: loading || showAnimation, isRounded: true, extraClassName: styles.retake_quiz_bottom_bar, submitLabel: "Update My Formula", onSave: submit })] }));
};
export default RetakeQuizExtraQuestions;
